export function registerGlobal(name, cls) {
    if (typeof window === "undefined") return;
    window.rock = window.rock || {};
    window.rock[name.toLowerCase()] = cls;
    if (!window[name]) window[name] = cls;
}
